export function parseIconClass(iconClass: string) {
  const baseIconClass = iconClass?.split(':').pop();
  const amendedIconClass = baseIconClass?.startsWith('icon-') ? baseIconClass : `icon-${baseIconClass}`;

  return amendedIconClass;
}
